/* eslint-disable consistent-return */
import { BASE_API_LIVE_SWAP } from 'config/constants/endpoints'
import fetchHelper from 'helpers/FetchHelper'
import { ReportStakingType, StakedDetailsType, unstakeingDto } from './type'

export const unstakingErrorCode = {
  STAKE_NOT_FOUND: 'Staking plan not found',
  STAKE_NOT_OWN: 'You do not own this staking plan',
  STAKE_NOT_RUNNING: 'Staking plan has expired',
  'UNSTAKE.LOCK_TIME': 'You are in lock time',
}

export const fetchStakingReport = (): Promise<ReportStakingType> => {
  return new Promise((resolve, reject) => {
    try {
      fetchHelper.fetch(`${BASE_API_LIVE_SWAP}/report`).then(([res, status]: any) => {
        if (res?.statusCode === 200) {
          resolve(res?.data)
        }

        reject(res)
      })
    } catch (err) {
      reject(err)
    }
  })
}

export const fetchUnstaking = (body: unstakeingDto): Promise<any> => {
  return new Promise<any>((resolve, reject) => {
    try {
      fetchHelper
        .fetch(`${BASE_API_LIVE_SWAP}/staking/un-stake`, {
          body: JSON.stringify(body),
          method: 'POST',
        })
        .then(([res, status]: any) => {
          if (res?.statusCode === 200) {
            resolve(res?.data)
          }

          reject(res)
        })
    } catch (err) {
      reject(err)
    }
  })
}

export const fetchPlanDetails = (planId: string): Promise<StakedDetailsType> => {
  return new Promise<StakedDetailsType>((resolve, reject) => {
    try {
      fetchHelper.fetch(`${BASE_API_LIVE_SWAP}/staking/detail/${planId}`).then(([res, status]: any) => {
        if (res?.statusCode === 200) {
          resolve(res?.data)
        }

        reject(res)
      })
    } catch (err) {
      reject(err)
    }
  })
}
